export const MAX_SAVED_PLANS = 24
export const MAX_COMPARE_PLANS = 3

export const planExtraInfo = [
  {
    key: 'primaryCare',
    value: 'Primary_Care_Visit_Details',
    icon: 'doctor'
  },
  {
    key: 'specialist',
    value: 'Specialist_Visit_Details',
    icon: 'plus'
  },
  {
    key: 'urgentCare',
    value: 'Urgent_Care',
    icon: 'ambulans'
  },
  {
    key: 'emergency',
    value: 'Emergency_Room_Services',
    icon: 'room'
  },
  {
    key: 'hospital',
    value: 'Inpatient_Hospital_Services',
    icon: 'hospital'
  },
  {
    key: 'outpatientServices',
    value: 'Outpatient_Services',
    icon: 'heart'
  },
  {
    key: 'genericDrugs',
    value: 'Generic_Drugs_Details_Comp',
    icon: 'pills'
  },
  {
    key: 'preferredBrandDrugs',
    value: 'Preferred_Brand_Drugs_Details',
    icon: 'drugs'
  },
  {
    key: 'rehabServices',
    value: 'Outpatient_Rehab_Services',
    icon: 'rehab'
  },
  {
    key: 'preventiveCare',
    value: 'Preventative_Care',
    icon: 'vaccin'
  },
  {
    key: 'proffessionalServices',
    value: 'Outpatient_and_Professional_Services',
    icon: 'building'
  },
  {
    key: 'xrayLab',
    value: 'X_Ray_and_Diagnostic_Imaging',
    icon: 'imaging'
  }
]
